// Звук вызова талона (чайм) для ТВ-страницы и кабинета менеджера.
//
// Проблема, которую решает общий контекст: браузеры блокируют автозвук, пока на
// странице не было ни одного жеста пользователя. На ТВ, который висит сутками,
// прежний код создавал НОВЫЙ AudioContext на каждый вызов и закрывал его — каждый
// такой контекст стартовал в состоянии `suspended` и играл в тишину, даже если по
// экрану кликали раньше. Теперь используется ОДИН общий контекст, который один раз
// разблокируется на первом касании/клике/нажатии клавиши и дальше живёт постоянно.

let sharedCtx = null;

function getAudioContext() {
	const Ctx = window.AudioContext || window.webkitAudioContext;
	if (!Ctx) return null;
	if (!sharedCtx) sharedCtx = new Ctx();
	// Если контекст приостановлен (политика автоплея) — пробуем возобновить.
	// Сработает молча, если уже был жест пользователя.
	if (sharedCtx.state === 'suspended') sharedCtx.resume().catch(() => {});
	return sharedCtx;
}

// Разблокировка звука на первом взаимодействии пользователя (один раз на всё время).
if (typeof window !== 'undefined') {
	const unlock = () => {
		const ctx = getAudioContext();
		if (ctx && ctx.state === 'running') {
			['click', 'touchstart', 'keydown', 'pointerdown'].forEach((e) =>
				window.removeEventListener(e, unlock)
			);
		}
	};
	['click', 'touchstart', 'keydown', 'pointerdown'].forEach((e) =>
		window.addEventListener(e, unlock, { passive: true })
	);
}

/**
 * Проигрывает короткий трёхнотный чайм (C5-E5-G5).
 * Громкость пик 0.38, хвост 1.1с.
 */
export function playChime() {
	try {
		const ctx = getAudioContext();
		if (!ctx) return;
		[
			{ freq: 523.25, delay: 0.0 },
			{ freq: 659.25, delay: 0.1 },
			{ freq: 783.99, delay: 0.2 },
		].forEach(({ freq, delay }) => {
			const osc = ctx.createOscillator();
			const gain = ctx.createGain();
			osc.connect(gain);
			gain.connect(ctx.destination);
			osc.type = 'sine';
			osc.frequency.value = freq;
			const t = ctx.currentTime + delay;
			gain.gain.setValueAtTime(0, t);
			gain.gain.linearRampToValueAtTime(0.38, t + 0.03);
			gain.gain.exponentialRampToValueAtTime(0.001, t + 1.1);
			osc.start(t);
			osc.stop(t + 1.1);
		});
		// Контекст НЕ закрываем — он переиспользуется (иначе снова suspended).
	} catch {
		// ignore
	}
}

export default playChime;
